import { Component, inject } from '@angular/core';
import { BillingService } from 'app/core/my-autoprop/billing/billing.service';
import { MyAutopropApi } from 'app/shared/service/my-autoprop-api.service';


@Component({
    template: `<!-- nothing, Upgrade Bundle modal should open itself -->`
})
export class UpgradeBundleModalComponent {

    private billingService = inject(BillingService);

    private myAutopropApi = inject(MyAutopropApi);

    constructor() {
        this.myAutopropApi.getFeatureBundles().subscribe(bundles => {
            this.billingService.openBundleDetail(bundles.payload[0]).subscribe();
        });
    }
}
